import React from 'react';

import PageTemplate from '../../components/template/PageTemplate';
import ProductPropertyRequestListContainer from '../../containers/product/ProductPropertyRequestListContainer';
import { PRODUCT_PAGE_NAME } from '../../constants/service/app/productConstants';

const ProductPropertyRequestList = () => {
  return (
    <PageTemplate pageName={PRODUCT_PAGE_NAME.PRODUCT_PROPERTY_REQUEST_LIST}>
      <ProductPropertyRequestListContainer pageName={PRODUCT_PAGE_NAME.PRODUCT_PROPERTY_REQUEST_LIST} />
    </PageTemplate>
  );
};

export default ProductPropertyRequestList;
